export enum WizardType {
	DEFAULT = 'default',
	TIP = 'tip',
	PAYMENT_METHOD = 'paymentMethod',
}
